<template lang="pug">
  .header-promo-bar(
    ref="promoBar"
    :style="barStyles"
  )
    .container
      .row
        .header-promo-bar__promo-content.column.small-12.large-6(v-html="promoBarText")
        .header-promo-bar__promo-account-content
          a.header-promo-bar__account-link(:href="userLink")
            icon(name="circle" size="12px" :style="iconStyles")
            span {{ userLabel }}
          span.header-promo-bar__account-link-divider(v-if="loggedIn")
          a.header-promo-bar__account-link(v-if="loggedIn" :href="wishListLink")
            icon(name="circle" size="12px" :style="iconStyles")
            span Favorites

</template>

<script>
  import BaseButton from 'scripts/components/buttons/BaseButton.vue';
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    components: {
      BaseButton,
      Icon
    },
    props: {
      promoBarText: String,
      promoBarBackgroundColor: String,
      promoBarTextColor: String,
      promoBarLinkHoverColor: String,
      loggedIn: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      barStyles() {
        let styles = '';
        styles += this.promoBarLinkHoverColor ? `--link-hover-color: ${this.promoBarLinkHoverColor}; ` : '';
        styles += this.promoBarTextColor ? `--promoBarTextColor: ${this.promoBarTextColor};` : '';
        styles += this.promoBarBackgroundColor ? `background-color: ${this.promoBarBackgroundColor}; ` : '';
        styles += this.promoBarTextColor ? `color: ${this.promoBarTextColor};` : '';

        return styles;
      },
      iconStyles(){
        return this.promoBarTextColor ? `fill: ${this.promoBarTextColor};` : '';
      },
      userLink() {
        return this.loggedIn ? '/account' : '/account/login';
      },
      userLabel() {
        return this.loggedIn ? 'My Account' : 'Account';
      },
    },
  };
</script>

<style lang="scss">
  .header-promo-bar {
    position: relative;
    padding: $spacing-unit;
    min-height: $mobile-header-promo-bar-height;

    @include desktop-up {
      min-height: $desktop-header-promo-bar-height;
    }
  }

  .header-promo-bar__promo-content {
    font-size: rem(14px);
    text-align: center;

    @include desktop-up {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
    }

    p {
      margin: 0;
      font-size: inherit;
    }

    a {
      color: inherit;

      &:hover {
        color: var(--link-hover-color);
      }
    }
  }

  .header-promo-bar__promo-account-content {
    display: none;

    @include desktop-up {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-left: auto;
    }
  }

  .header-promo-bar__account-link {
    display: flex;
    align-items: center;
    font-size: rem(14px);
    color: inherit;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

    .icon {
      margin-right: $spacing-unit * 2;
    }
  }

  .header-promo-bar__account-link-divider {
    border-left: 1px solid var(--promoBarTextColor);
    margin: 0 ($spacing-unit * 3);
    height: 16px;
  }
</style>
